/**
 * useTabPermissions — convenience hook for views with tabs
 *
 * Usage:
 *   const { visibleTabs, getPermission, canWriteTab, isReadOnly } = useTabPermissions('insurance', INSURANCE_TABS);
 */

import { useMemo } from 'react';
import { useProfile } from '../context/ProfileContext.jsx';

export function useTabPermissions(moduleId, allTabs = []) {
  const { getTabPermission, filterTabs, canWrite, isReadOnly } = useProfile();

  const visibleTabs = useMemo(
    () => filterTabs(moduleId, allTabs),
    [moduleId, allTabs, filterTabs]
  );

  const getPermission = (tabId) => getTabPermission(moduleId, tabId);

  const canWriteTab = (tabId) => canWrite(moduleId, tabId);

  return {
    visibleTabs,
    getPermission,
    canWriteTab,
    isReadOnly,
  };
}

export default useTabPermissions;
